import axios from 'axios'
import { get } from 'utils/request'

export const getLocations = async (connectionType: string) =>
  await get(`/api/locations`, {
    params: {
      conn_type: connectionType,
    },
  })

export const getLocationTargets = async (data: any) =>
  await get(`/api/location-targets`, {
    params: data,
  })

export const checkProxyList = async (data: string[]) =>
  await axios
    .post('https://proxycheck.soax.com/proxytest', {
      proxies: data,
    })
    .then((response) => {
      return response.data
    })
    .catch(function (error) {
      return Promise.reject(error.response)
    })
